import React from 'react';
import { createRoot } from 'react-dom/client';
import FrameExtractor from './pages/nativetools/image/frameextractor/frameextractor';
import ImageResizer from './pages/nativetools/image/edit/imageresizer/imageresizer';
import WordCounter from './pages/nativetools/text/wordcounter/wordcounter';
window.mountMyWidget = (containerId, componentType, props) => {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error(`Container with id "${containerId}" not found`);
        return;
    }
    const root = createRoot(container);
    switch (componentType) {
        case 'frameextractor':
            root.render(React.createElement(FrameExtractor, null));
            break;
        case 'imageresizer':
            root.render(React.createElement(ImageResizer, null));
            break;
        case 'wordcounter':
            root.render(React.createElement(WordCounter, null));
            break;
        default:
            console.error(`Unknown component type: "${componentType}"`);
    }
};
